import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Paginated } from '@sd-portal/shared/models';

import { AuditLogLite } from './+models/audit-log-lite.model';
import { UsersAuditUser } from './+models/users-audit.model';

@Injectable()
export class UsersAuditService {
  private readonly apiUrl = '/sdapi/profile/audit/users';

  constructor(private readonly http: HttpClient) {}

  private paginationParams(pageNumber: number, pageSize: number): HttpParams {
    return new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
  }

  getUsers(pageNumber: number, pageSize: number): Observable<Paginated<UsersAuditUser>> {
    return this.http.get<Paginated<UsersAuditUser>>(this.apiUrl, {
      params: this.paginationParams(pageNumber, pageSize)
    });
  }

  getUserLogs(
    userId: number,
    pageNumber: number,
    pageSize: number
  ): Observable<Paginated<AuditLogLite>> {
    return this.http.get<Paginated<AuditLogLite>>(`${this.apiUrl}/${userId}/logs`, {
      params: this.paginationParams(pageNumber, pageSize)
    });
  }

  getUserRoleLogs(
    userRoleId: number,
    pageNumber: number,
    pageSize: number
  ): Observable<Paginated<AuditLogLite>> {
    return this.http.get<Paginated<AuditLogLite>>(`${this.apiUrl}/roles/${userRoleId}/logs`, {
      params: this.paginationParams(pageNumber, pageSize)
    });
  }
}
